import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0103',
    ecrans: ['00-2'],
    params: ['?geccleint']
});
